import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAccountNotifiersAction,
  updateAllSubscriptionsAction,
  updateSubscriptionAction,
} from "src/features/profile/settings/state/liveNotificationsAction";
import { AccountNotifier } from "src/features/profile/settings/types/liveNotifications.type";

import addUserSessionScopeReducer from "state/hor/addUserSessionScopeReducer";

export type LiveNotificationsState = {
  notifiers: AccountNotifier[] | null;
};

const initialState: LiveNotificationsState = {
  notifiers: null,
};

const liveNotificationsSlice = createSlice({
  name: "profile-settings-live-notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addUserSessionScopeReducer(
      builder
        .addCase(fetchAccountNotifiersAction.fulfilled, (state, action) => {
          state.notifiers = action.payload.notifiers;
        })
        .addCase(updateSubscriptionAction.fulfilled, (state, action) => {
          const { notifierId, enabled } = action.meta.arg || {};
          if (!state.notifiers) {
            return;
          }
          state.notifiers = state.notifiers.map((notifier) =>
            notifier.accountId === notifierId
              ? { ...notifier, notificationEnabled: enabled }
              : notifier
          );
        })
        .addCase(updateAllSubscriptionsAction.fulfilled, (state, action) => {
          const { enabled } = action.meta.arg || {};
          if (!state.notifiers) {
            return;
          }
          state.notifiers = state.notifiers.map((notifier) => ({
            ...notifier,
            notificationEnabled: enabled,
          }));
        }),
      () => initialState
    );
  },
});

export default liveNotificationsSlice.reducer;
